import { Container, Link, Typography } from "@octopus-energy/coral/atoms"
import { useTranslations } from "next-intl"
import { storyblokRoutesPaths } from "@/routes/storyblok"

export function GdprPrivacyPolicy() {
    const t = useTranslations("GdprPrivacyPolicy")

    return (
        <Container
            fullWidth
            maxWidthPreset="lg"
            marginX="auto"
            paddingX="sm"
            paddingY="xl"
            attributes={{ role: "note" }}
        >
            <Typography textStyle="caption">
                {t.rich("onboarding", {
                    link: (chunks) => (
                        <Link href={storyblokRoutesPaths.privacyPolicy.resolve()}>{chunks}</Link>
                    ),
                })}
            </Typography>
        </Container>
    )
}

GdprPrivacyPolicy.messages = ["GdprPrivacyPolicy"] as const
